import Box from '@/Atoms/Box';
import CCButton from '@/Atoms/CCButton';
import CCText from '@/Atoms/CCText';
import React, {useCallback, useEffect, useState, useRef} from 'react';
import {FontSizes, hs, vs} from '@/Utils/Dimensions';
import {View} from 'react-native';
import {Modal, Text, Button} from 'react-native';
import Animated, {
  useSharedValue,
  useAnimatedStyle,
  interpolateColor,
  interpolate,
  withTiming,
} from 'react-native-reanimated';
import {styles} from './styles';
import challenge from '@/Assets/Images/png/challenge@3x.png';
import useAnimation from '@/Hooks/useAnimation';
import CCColors from '@/Utils/CCColors';
import {useSocket} from '@/Hooks/UseSocket';
import {useNavigation, useRoute} from '@react-navigation/native';
import {
  getLocalStorage,
  removeLocalStorage,
  setLocalStorage,
} from '@/Utils/CommonUtils';
import useGamePlayState from '@/Store/GamePlayStore';
import ChallengeRejected from '@/Screens/PlayChess/components/ChallengeRejected';
import useUpdateUserSettingsApi from '@/Hooks/ProfileApi/updateSettingsApi';
import useGetProfileApi from '@/Hooks/ProfileApi/profileApi';
import {useNotificationStore} from '@/Store/useNotificationStore';
import ChessRestClient from '@/Api/ChessRestClient';
import {capitalizeFirstLetter, useUserRaisedIssues} from '@/Utils/CommonUtils';
import FairPlayAlertModal from '@/Components/FairPlayAlertModal';
// const schema = require('/Users/nitu/Circlechess/cc-client-sdk/lib/schema.js');
// const schema = require('/var/www/game-service/cc-client-sdk/lib/schema.js');
const {schema, cc_ws_client} = require('../../../CCClientSdk');

function ChallengeComponent(props) {
  const {username} = props;
  const {fetchUserRaisedIssues} = useUserRaisedIssues();
  const [showChallengeRequest, setShowChallengeRequest] = useState(false);
  const [ChallengeOpponent, setChallengeOpponent] = useState('');
  const [ChallengeOpponentUsername, setChallengeOpponentUsername] =
    useState('');
  const [ChallengeMoveTimer, setChallengeMoveTimer] = useState('');
  const [ChallengeIncrement, setChallengeIncrement] = useState('');
  const [ChallengeVariantId, setChallengeVariantId] = useState('');
  const [ChallengePosition, setChallengePosition] = useState(
    'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
  );
  const [ChallengeWhite, setChallengeWhite] = useState('');
  const [alowUpdate, setAllowUpdate] = useState(false);
  const [gameDetails, setGameDetails] = useState('');
  const [gamePlayMode, setGamePlayMode] = useState('Play');
  const [tableId, setTableId] = useState('');
  const [dndUsers, setDndUsers] = useState([])

  // ── FairPlay Phase 3: alert queue state ──────────────────────────────────
  const [fairplayAlerts, setFairplayAlerts] = useState([]);
  const [userExternalIds, setUserExternalIds] = useState({
    fide_id: null,
    lic_name: null,
    cdc_name: null,
    username: '',
  });

  const gameplayStore = useGamePlayState();
  const playingRef = useRef(gameplayStore.playing);

  const allowChallengeRef = useRef(gameplayStore.allowChallenge);
  const dndUsersRef = useRef(dndUsers);

  useEffect(() => {
    allowChallengeRef.current = gameplayStore.allowChallenge;
  }, [gameplayStore.allowChallenge]);

  useEffect(() => {
    dndUsersRef.current = dndUsers;
  }, [dndUsers]);

  const canProcessChallenge = useCallback((data) => {
    const opponentId = Number(data.opponent?.split(':')[0]);

    return (
      allowChallengeRef.current ||
      dndUsersRef.current?.includes(opponentId)
    );
  }, []);

  const handleOnSuccessB = item => {
    const addInboxMessage = useNotificationStore.getState().addInboxMessage;
    item.forEach(i => {
      if (i.unread_count > 0) {
        addInboxMessage({
          id:
            i.last_message?.id?.toString() ??
            `${i.id}-${Date.now()}`,
          requestId: i.id?.toString(),
          message: i.last_message?.body || '(No message)',
          userId: i.last_message?.sender || 'Unknown',
          senderName: i.last_message?.sender || 'Someone',
          type: 'inbox',
          timestamp:
            i.last_message?.created_at || new Date().toISOString(),
          isNew: true,
        });
      }
    });
  };

  const fetchInbox = async () => {
    const res = await ChessRestClient.get('/inbox/get_inbox');
    handleOnSuccessB(res.data);
    return res.data;
  };

  useEffect(() => {
    if (playingRef.current && !gameplayStore.playing) {
      setShowChallengeRequest(false);
      gameplayStore.setShowChallengeExpire(false);
      gameplayStore.setShowChallengeCancel(false);
    }
    playingRef.current = gameplayStore.playing;
  }, [gameplayStore.playing]);

  useEffect(() => {
    if (
      gameplayStore.showChallengeExpire ||
      gameplayStore.showChallengeCancel ||
      gameplayStore.showChallengeReject
    ) {
      setShowChallengeRequest(false);
    }
  }, [
    gameplayStore.showChallengeExpire,
    gameplayStore.showChallengeCancel,
    gameplayStore.showChallengeReject,
  ]);

  const originalInfo = console.info;

  const navigation = useNavigation();
  // const route = useRoute();

  const socket = useSocket();
  useEffect(() => {
    if (challengeRequestCallback && socket) {
      socket.registerMessageType(
        'challenge_game_request',
        schema.challengeGameMsgSchema,
      );
      socket.registerMessageType(
        'challenge_request_check',
        schema.challengeGameMsgSchema,
      );
      socket.registerMessageHandler(
        'challenge_request_check',
        function (socket, data) {
          challengeRequestCallback(socket, data);
        },
      );
    }

    if (challengeCancelCallback && socket) {
      socket.registerMessageType(
        'challenge_cancel',
        schema.challengeGameMsgSchema,
      );
      socket.registerMessageHandler(
        'challenge_cancel',
        function (socket, data) {
          challengeCancelCallback(socket, data);
        },
      );
    }
    if (challengeExpiredCallback && socket) {
      socket.registerMessageType(
        'challenge_request_expire',
        schema.challengeGameMsgSchema,
      );
      socket.registerMessageHandler(
        'challenge_request_expire',
        function (socket, data) {
          challengeExpiredCallback(socket, data);
        },
      );
    }
    if (socket) {
      // Register once with a named handler + cleanup. Previously this raw
      // listener was re-added on every effect run with no removal, so a single
      // server event fired the modal many times (the modal storm); the
      // arbitrary 5s setTimeout re-raise compounded it.
      const handleChangeClient = function (data) {
        console.info('Change in client_connection on socketid :', socket.id);
        // After accept-from-non-active-tab, the server follows up swapActive's
        // MOVE_CLIENT with a second event carrying message='playing_elsewhere'
        // — the user is now playing on another tab, so the stale activate-here
        // modal on this (demoted) tab is dismissed instead of being shown.
        if (data?.message === 'playing_elsewhere') {
          gameplayStore.setShowChangeInClient(false);
        } else {
          gameplayStore.setShowChangeInClient(true);
        }
      };
      socket.on('change_client_connection', handleChangeClient);
      return () => {
        socket.off?.('change_client_connection', handleChangeClient);
      };
    }
  }, [socket]);

  function challengeExpiredCallback(socket, data) {
    if (!allowChallengeRef.current) {
      return; // hard drop
    }
    console.info('...challenge_reject message data...', JSON.stringify(data));
    if (!playingRef.current && !gameplayStore.tournamentPlay) {
      gameplayStore?.setShowChallengeExpire(true);
    }
    setShowChallengeRequest(false);
  }

  function challengeCancelCallback(socket, data) {
    if (!allowChallengeRef.current) {
      return; // hard drop
    }
    console.info('...challenge_cancel message data...', JSON.stringify(data));
    if (!playingRef.current && !gameplayStore.tournamentPlay) {
      gameplayStore?.setShowChallengeExpire(true);
    }
    setShowChallengeRequest(false);
  }

  function challengeRequestCallback(socket, data) {
    if (!canProcessChallenge(data)) {
      return; // hard drop
    }
    console.info(
      '...challenge_request_check message data...',
      JSON.stringify(data),
      gameplayStore.allowChallenge,
    );
    if (
      data.userId == username &&
      !playingRef.current &&
      !gameplayStore.tournamentPlay
    ) {
      setShowChallengeRequest(true);
      setChallengeOpponent(data.opponent.split(':')[0]);
      setChallengeOpponentUsername(data.opponent.split(':')[1]);
      setChallengeVariantId(data.variantId);
      setChallengeMoveTimer(data.playerMoveTimer);
      setChallengeIncrement(data.moveTimeIncrement);
      //   game?.load(data?.gameState || 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1');
      //   if (
      //     game?.fen() !=
      //     'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1'
      //   ) {
      //     setPosition(game?.fen());
      //   }

      setChallengePosition(
        data?.gameState ||
        'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
      );
      setTableId(data.tableId);
      setChallengeWhite(data.white);
      setGamePlayMode(data.gamePlayMode);
      gameplayStore?.setShowEndGameModal(false);
      gameplayStore?.setShowChallengeCancel(false);
      gameplayStore?.setShowChallengeReject(false);
      gameplayStore?.setShowChallengeExpire(false);
      // setBlackPlayer(data.black);
    } // Show the challenge request modal
  }

  const handleChallengeResponse = async accepted => {
    let packet = {};
    packet.requestId = new Date().getTime().toString();
    packet.variantId = ChallengeVariantId;
    packet.userId = username;
    packet.opponent = ChallengeOpponent;
    packet.playerMoveTimer = ChallengeMoveTimer;
    packet.moveTimeIncrement = ChallengeIncrement;
    packet.gameState = ChallengePosition;
    packet.white = ChallengeWhite;
    packet.black = '';
    packet.gamePlayMode = gamePlayMode;

    // packet.tableId = tableId;
    if (accepted) {
      packet.type = 'challenge_accept_response';
      console.info(
        'challenge accept response Packet = ',
        JSON.stringify(packet),
      );
      await setLocalStorage('challengePacket', packet);

      navigation.navigate('PlayChess');
      setTimeout(() => {
        socket.send_msg('challenge_game_request', packet);
      }, 800);
    } else {
      packet.type = 'challenge_reject';
      console.info(
        'challenge reject response Packet = ',
        JSON.stringify(packet),
      );
      socket.send_msg('challenge_game_request', packet);
    }

    setShowChallengeRequest(false); // Close the Challenge request modal
  };

  const handle_challenge_reject = () => {
    gameplayStore?.setShowChallengeCancel(false);
    gameplayStore?.setShowChallengeExpire(false);
  };

  const [gemsAnimValue, setGemsAnimValue] = useAnimation({
    prop: 'backgroundColor',
    start: 'rgba(255, 255, 255, 0)',
    end: CCColors.Green,
    isColor: true,
  });

  // Called when the settings update succeeds
  const handleUpdateSettingsSuccess = data => {
    if (data?.data) {
      const {allow_challenge, chessboard_theme} = data.data;
      // update local state, context, or UI accordingly
      console.log('New settings:', {allow_challenge, chessboard_theme});
    } else {
      console.warn('Settings update succeeded but returned no data.');
    }
  };

  // Called when the settings update fails
  const handleUpdateSettingsError = data => {
    console.error('❌ Failed to update settings:', data);

    if (data?.error) {
      // show error toast or message
      console.error('Server error:', data.error);
    } else if (data?.errors) {
      console.error('Validation errors:', data.errors);
    }
  };

  const {
    mutate: updateSettings,
    data: settingsData,
    error: settingsError,
    isLoading: isUpdating,
  } = useUpdateUserSettingsApi(
    handleUpdateSettingsSuccess,
    handleUpdateSettingsError,
  );
  const handleProfileGetSuccess = responseData => {
    const userSettings = responseData?.data?.user_settings;
    const storeDnd = async () => {
      await setLocalStorage(
        'dnd-mode',
        userSettings?.allow_challenge ? 'everyone' : 'nobody',
      );

      if (userSettings?.chessboard_theme) {
        await setLocalStorage('color', userSettings?.chessboard_theme);
      }
      setAllowUpdate(true);
      gameplayStore?.setAllowChallenge(userSettings?.allow_challenge);
    };
    storeDnd();
    setDndUsers(userSettings?.dnd_users);

    // ── FairPlay Phase 3: parse alerts + user external IDs ─────────────────
    const alerts = responseData?.data?.fairplay_alerts || [];
    setFairplayAlerts(alerts);
    const fields = responseData?.data?.user?.[0]?.fields || {};
    setUserExternalIds({
      fide_id: fields?.fide_id || null,
      lic_name: fields?.lic_name || null,
      cdc_name: fields?.cdc_name || null,
      username: fields?.username || username || '',
    });
  };

  const handleOnError = () => {};
  const {
    mutate: getProfile,
    data: validatedData,
    error: validatedError,
    isLoading,
  } = useGetProfileApi(handleProfileGetSuccess, handleOnError);
  useEffect(() => {
    const mode = async () => {
      const dndValue = await getLocalStorage('dnd-mode');
      if (dndValue && alowUpdate) {
        updateSettings({allow_challenge: gameplayStore?.allowChallenge});
      }
    };
    mode();
  }, [gameplayStore?.allowChallenge]);
  useEffect(() => {
    const update = async () => {
      await removeLocalStorage('dnd-mode');
    };
    update();
    getProfile();
    fetchInbox();
    fetchUserRaisedIssues();
    const redirectToOriginalPath = async () => {
      const storedPath = await getLocalStorage('current_path');
      await removeLocalStorage('current_path');
      if (
        storedPath &&
        storedPath !== 'login' &&
        storedPath !== '' &&
        storedPath !== 'home'
      ) {
        const capitalizedPath = capitalizeFirstLetter(storedPath);
        const isCheckoutPage = storedPath === 'csoc-new-payment';
        navigation.navigate(isCheckoutPage ? 'CsocNewPayment' : capitalizedPath);
      }
    };
    redirectToOriginalPath();
  }, []);

  return (
    <View>
      <Modal
        animationType="none"
        transparent={true}
        visible={
          showChallengeRequest &&
          !gameplayStore?.showChallengeCancel &&
          !gameplayStore?.showChallengeExpire &&
          !gameplayStore.tournamentPlay &&
          !gameplayStore.playing &&
          (gameplayStore.allowChallenge || dndUsers?.includes(Number(ChallengeOpponent)))
        }
        onRequestClose={() => {
          setShowChallengeRequest(false);
        }}>
        <View style={styles.centeredView}>
          <View style={styles.modalView}>
            <img src={challenge} style={{width: hs(208), height: vs(208)}} />

            {/* const handle_challenge_reject = () => {
         gameplayStore?.setShowChallengeCancel(false);
         gameplayStore?.setShowChallengeExpire(false);
         setShowChallengeRequest(false);
     }; */}
            <Animated.View style={[styles.progressBarWrapper, gemsAnimValue]}>
              <View style={styles.progressBar}>
                <View style={[styles.progressBarFilling, {width: '43%'}]} />
              </View>
            </Animated.View>

            <CCText fontSize={FontSizes[16]} style={{color: 'black'}}>
              {ChallengeOpponentUsername} has challenged you!
            </CCText>
            <CCText
              fontSize={FontSizes[12]}
              style={{color: 'black', marginTop: 16}}>
              {(ChallengeMoveTimer / 60000).toString() +
                ' + ' +
                (ChallengeIncrement / 1000).toString()}{' '}
              Rated | You are {ChallengeWhite == username ? 'White' : 'Black'}
            </CCText>

            <Box flexDirection="row" style={{marginTop: 32}}>
              <CCButton
                onPress={e => handleChallengeResponse(false)}
                style={{marginRight: 8}}>
                Reject
              </CCButton>
              <CCButton
                onPress={e => handleChallengeResponse(true)}
                type="outline">
                Accept
              </CCButton>
            </Box>
          </View>
        </View>
      </Modal>

      <ChallengeRejected
        Visible={gameplayStore?.showChallengeExpire && !gameplayStore.playing && gameplayStore.allowChallenge }
        message="The challenge has expired!"
        handle_close={handle_challenge_reject}
      />
      <ChallengeRejected
        Visible={gameplayStore?.showChallengeCancel && !gameplayStore.playing}
        message="Challenge Cancelled!"
        handle_close={handle_challenge_reject}
      />

      {/* ── FairPlay Phase 3: alert popup ── */}
      <FairPlayAlertModal
        alerts={fairplayAlerts}
        userProfile={userExternalIds}
      />
    </View>
  );
}

export default ChallengeComponent;
